export default __webpack_public_path__ + "static/media/diver.3148144c.png";